import { render, staticRenderFns } from "./FlexCheckinSetting.vue?vue&type=template&id=f0d82ed2"
import script from "./FlexCheckinSetting.vue?vue&type=script&lang=js"
export * from "./FlexCheckinSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports